// 消息推送管理路由
export default {
    path: 'msgPush',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '消息推送管理'},
    children: [
        // App内升级通知
        // {
        //     path: 'updateNotify',
        //     component: () => import('@/components/RouterView'),
        //     redirect: '/msgPush/updateNotify/list',
        //     meta: { title: 'APP内升级通知'},
        //     children: [
        //         {
        //             path: 'list',
        //             component: () => import('@/views/msgPushManage/updateNotify/list.vue'),
        //             meta: {title: 'APP内升级通知列表'}
        //         },
        //         {
        //             path: 'edit/:id',
        //             component: () => import('@/views/msgPushManage/updateNotify/edit.vue'),
        //             name: 'editUpdateNotify',
        //             meta: {title: '编辑APP内升级通知'},
        //             props: true
        //         },
        //         {
        //             path: 'add',
        //             component: () => import('@/views/msgPushManage/updateNotify/edit.vue'),
        //             name: 'addUpdateNotify',
        //             meta: {title: '新建APP内升级通知'},
        //             props: true
        //         }
        //     ]
        // }
    ]
}